import gsap from "gsap";

function getRandomDirection() {
  let theta = Math.random() * Math.PI * 2;
  let x = 300 * Math.sin(theta);
  let y = 300 * Math.cos(theta);
  return { x, y };
}

function initQuote() {
  let animation = gsap.timeline({
    scrollTrigger: {
      scrub: true,
      trigger: ".people__quote",
      start: "top 50%",
      end: "+=200",
      refreshPriority: 100,
    },
  });

  for (let i = 1; i <= 6; i++) {
    let dir = getRandomDirection();
    animation.fromTo(
      `.smallquote blockquote .span-${i}`,
      {
        x: dir.x,
        y: dir.y,
      },
      {
        x: 0,
        y: 0,
        duration: 0.3,
        ease: "none",
      },
      0
    );
  }
}

if (document.querySelector(".people__quote")) {
  initQuote();
}
